module.exports = __webpack_public_path__ + "static/media/test17_1.2d8e51e6.png";